// TODO-PROD: ganti draft-copy mode dengan SMTP real (nodemailer/Resend) via backend /api/email/send.
// Saat ini Phase 6B prototype: generate draft subject + body untuk di-copy manual.

import { formatTanggalID } from "./hariKerja";

export function buildEmailDraft({ jenis, kasus, terperiksa, sisaHK }) {
  const subject = subjectTemplate(jenis, kasus);
  const body = bodyTemplate({ jenis, kasus, terperiksa, sisaHK });
  const mailto = `mailto:${encodeURIComponent(
    terperiksa?.email || "",
  )}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  return { subject, body, mailto };
}

function subjectTemplate(jenis, kasus) {
  const no = kasus.nomorLHP || "LHP";
  switch (jenis) {
    case "T0":
      return `[IRBANSUS] Penerbitan & Tindak Lanjut ${no}`;
    case "H15":
      return `[PERINGATAN] 15 Hari Kerja Tersisa — TL ${no}`;
    case "H7":
      return `[MENDESAK] 7 Hari Kerja Tersisa — TL ${no}`;
    case "H3":
      return `[FINAL] 3 Hari Kerja Tersisa — TL ${no}`;
    case "H0":
      return `[JATUH TEMPO HARI INI] TL ${no}`;
    case "H1":
      return `[BATAS TERLEWAT] TL ${no} — Eskalasi ke IRBAN`;
    default:
      return `[IRBANSUS] Notifikasi ${no}`;
  }
}

function bodyTemplate({ jenis, kasus, terperiksa, sisaHK }) {
  const header = `Yth. ${terperiksa?.namaPejabat || "Bapak/Ibu"}\n${terperiksa?.jabatan || "-"} — ${terperiksa?.namaInstansi || "-"}`;
  const common = `\n\nDengan hormat,\n\nBerkenaan dengan LHP No. ${kasus.nomorLHP} tertanggal ${formatTanggalID(kasus.tanggalLHP)} dengan judul "${kasus.judulKasus}",\nbatas waktu tindak lanjut jatuh pada tanggal ${formatTanggalID(kasus.deadlineTL60HK)}.`;
  let specific = "";
  switch (jenis) {
    case "T0":
      specific = `\n\nKami menginformasikan bahwa tindak lanjut wajib diselesaikan dalam 60 hari kerja sebelum tanggal jatuh tempo tersebut.`;
      break;
    case "H15":
      specific = `\n\nPERINGATAN: sisa waktu tindak lanjut adalah ${sisaHK} hari kerja. Mohon segera menyelesaikan rekomendasi yang belum tuntas.`;
      break;
    case "H7":
      specific = `\n\nMENDESAK: sisa waktu tindak lanjut adalah ${sisaHK} hari kerja. Tim Irbansus meminta percepatan penyelesaian rekomendasi.`;
      break;
    case "H3":
      specific = `\n\nFINAL: sisa waktu tindak lanjut hanya ${sisaHK} hari kerja. Risiko eskalasi ke Inspektur Pembantu Khusus (IRBAN).`;
      break;
    case "H0":
      specific = `\n\nJATUH TEMPO HARI INI: tindak lanjut atas rekomendasi belum seluruhnya selesai. Mohon segera diselesaikan.`;
      break;
    case "H1":
      specific = `\n\nBATAS WAKTU TERLEWAT: status kasus diteruskan ke IRBAN untuk tindakan lanjut. Mohon segera berkoordinasi.`;
      break;
    default:
      specific = "";
  }
  const footer = `\n\nHormat kami,\nTim Irbansus — Inspektorat Daerah Kabupaten Tasikmalaya`;
  return header + common + specific + footer;
}
